import { useQuery, UseQueryResult } from 'react-query'

import { FetchTireParamsResults, TireParamsPayload } from './types'
import { fetchSearchFilters } from './services'

export default function useSearchFiltersQuery(
   categoryUuid: string,
   payload?: TireParamsPayload
): UseQueryResult<FetchTireParamsResults> {
   return useQuery(['searchFilters', categoryUuid, payload], () => fetchSearchFilters(categoryUuid, payload), {
      staleTime: 60 * 60 * 1000,
      enabled: !!categoryUuid,
   })
}
